import type { RadioStation } from '@/types';

/**
 * Skida prefiks "Suton Radio - " sa naziva stanice za prikaz u uskim mjestima
 * (kartice, mini player). Puno ime ostaje u CMS-u i koristi se na drugim mjestima.
 *
 * Primjeri:
 *   "Suton Radio - 80-te Narodna" → "80-te Narodna"
 *   "Suton Radio - LIVE"          → "LIVE"
 *   "Suton Radio"                 → "Suton Radio"  (već kratko, ne dira)
 *   "Naxi Radio"                  → "Naxi Radio"   (nije Suton, ne dira)
 */
export function getStationDisplayName(name: string): string {
  if (!name) return '';
  const prefix = 'Suton Radio - ';
  if (name.startsWith(prefix)) {
    return name.slice(prefix.length);
  }
  return name;
}

/**
 * Vraća lokalizovani naslov stanice za prikaz u kartici.
 * Fallback chain:
 *   1. station.nameTranslations[locale]
 *   2. station.nameTranslations['bs']
 *   3. getStationDisplayName(station.name) — strip prefix iz original name-a
 *
 * Primjer:
 *   station.name = "Suton Radio - 80-te Narodna"
 *   station.nameTranslations = { de: "Volksmusik der 80er", en: "80s Folk" }
 *   locale = "de"  → "Volksmusik der 80er"
 *   locale = "fr"  → "80-te Narodna" (final fallback)
 */
export function getLocalizedStationName(station: RadioStation, locale: string): string {
  const translations = station.nameTranslations || {};

  if (locale && translations[locale]) {
    return translations[locale];
  }

  if (translations.bs) {
    return translations.bs;
  }

  return getStationDisplayName(station.name);
}
